import { storeToRefs } from "pinia";
import { computed, type MaybeRefOrGetter, toValue, watch } from "vue";

import { useSocialIntegrationsStore } from "shared/stores/socialIntegrations";
import type { Maybe, Nullish } from "shared/types";
import type { SocialAccountOption } from "shared/types/social";

export function useChartSocialAccount(
  accountId: MaybeRefOrGetter<Nullish<string>>
) {
  const socialIntegrationsStore = useSocialIntegrationsStore();

  const { socialAccountOptionsRecord } = storeToRefs(socialIntegrationsStore);

  const socialAccount = computed<Maybe<SocialAccountOption>>(() => {
    const id = toValue(accountId);

    if (!id) return undefined;

    return socialAccountOptionsRecord.value[id];
  });

  watch(
    () => toValue(accountId),
    async (id) => {
      if (!id || socialAccount.value) return;

      try {
        await socialIntegrationsStore.loadIntegrations();
      } catch {
        // naming the account is supplementary, so a failed load just hides it
      }
    },
    { immediate: true }
  );

  return { socialAccount };
}
